import React from 'react';

const NecrovaComingSoon = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="p-8 rounded-lg border border-purple-600 bg-gray-800 max-w-md w-full">
        <div className="flex justify-center mb-6">
          <div className="flex items-center justify-center">
          <img 
          src="https://cdn.4fingerstudios.com/Necrova/NecrovaStuffas/Full.png" 
          width="60" 
          height="60" 
          alt="Description of image"
        />
          </div>
        </div>
        
        <h1 className="text-2xl font-bold mb-4 text-center text-purple-500">
          Coming Soon
        </h1>
        
        <p className="text-black text-center mb-8">
          We're working hard behind the scenes to bring something amazing to you. Stay tuned!
        </p>
        
        <div className="flex justify-center">
  <a
    href="https://4fingerstudios.com/Necrova/Login" // Replace with your actual destination URL
    className="px-6 py-3 bg-transparent border border-purple-600 text-black rounded hover:bg-purple-600 hover:text-white transition-colors duration-300 text-center inline-block"
  >
    Continue to Dashboard
  </a>
</div>

        
        <div className="mt-8 pt-4 border-t border-purple-600 opacity-50">
          <p className="text-black text-center text-sm">
            NECROVA INDUSTRIES • Pioneering the Future
          </p>
        </div>
      </div>
    </div>
  );
};

export default NecrovaComingSoon;
